import { userAtom, userTipsAtom } from "state-atoms/users-atoms";
import { useAtomValue } from "jotai";
import { TipName } from "shared/datamodel/schemas";
import { useMemo } from "react";
import { isCIM } from "utils/url-utils";

const NON_TEMPLATE_ONBOARDING_TIPS = [
  TipName.onboardingTeamSize,
  TipName.onboardingChooseTemplate,
  TipName.onboardingInvite,
];

const REGULAR_ONBOARDING_TIPS = [TipName.onboardingTeamSize, TipName.onboardingInvite];

export function useCurrentAccountOnboardingTip() {
  const tips = useAtomValue(userTipsAtom);

  return useMemo(() => {
    const filteredSteps = NON_TEMPLATE_ONBOARDING_TIPS.filter((step) => !tips.has(step));

    return filteredSteps.length === 0 ? null : filteredSteps[0];
  }, [tips]);
}

export default function useShowOnboarding() {
  const userTips = useAtomValue(userTipsAtom);
  const user = useAtomValue(userAtom);
  if (isCIM()) {
    return false;
  }

  return user?.serialNumber === 1 && !REGULAR_ONBOARDING_TIPS.every((tip) => userTips.has(tip));
}
